var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#6A00FF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8267 50.0613C40.2427 49.5582 46.2617 43.5811 46.8194 36.1691C47.1827 31.3416 45.2393 26.9339 41.9771 23.934L43.847 22.0642L44.7291 22.9463C45.3162 23.5335 46.2682 23.5335 46.8553 22.9463C47.4424 22.3592 47.4424 21.4073 46.8553 20.8201L42.9497 16.9146C42.3626 16.3275 41.4107 16.3275 40.8235 16.9146L40.8194 16.9187C40.2339 17.5042 40.2321 18.453 40.8153 19.0408L41.7057 19.938L39.5343 22.1094C37.6644 20.9785 35.5533 20.2396 33.2914 20.0134V16.9221H34.8038C35.6342 16.9221 36.3073 16.249 36.3073 15.4187V15.4097C36.3073 14.5794 35.6342 13.9062 34.8038 13.9062H28.7631C27.9328 13.9062 27.2597 14.5794 27.2597 15.4097V15.4187C27.2597 16.249 27.9328 16.9221 28.7631 16.9221H30.2755V20.0134C22.6755 20.7674 16.7041 27.2213 16.7041 35.0174C16.7041 43.6713 24.0491 50.6567 32.8267 50.0613ZM31.6764 25.9697H31.8905C32.6797 25.9697 33.3345 26.5799 33.3902 27.3672L33.9238 34.9158C33.9853 35.7857 33.2962 36.5253 32.4241 36.5253H31.1428C30.2708 36.5253 29.5817 35.7857 29.6431 34.9158L30.1767 27.3672C30.2324 26.5799 30.8873 25.9697 31.6764 25.9697Z",
    fill: "#6A00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerTracking);
export default __webpack_public_path__ + "static/media/timer-tracking.a34a46da5cb1475b5affd57810a5d3e5.svg";
export { ForwardRef as ReactComponent };